import {DIALOGDATA} from '../Actions/Types'

const initialState={
    data:null
}
export default function (state = initialState,action) {
    // console.log(action)
    switch (action.type) {
        case DIALOGDATA:
            return {
                // ...state,
                data: action.payload,
            }
        default:
            return state
    }
}